import type { ColDef } from 'ag-grid-community';

/**
 * Construye el formato de la celda a partir de dos funciones,
 * la primera que toma el valor del dato recuperado y lo
 * transforma al formato esperado
 *
 * La segunda toma el valor formateado y le agrega cualquier
 * característica de estilo, por ejemplo un ícono
 * @template TData
 * @template TValue
 * @param {NonNullable<ColDef<TData, TValue>['valueFormatter']>} formatter
 * @param {NonNullable<ColDef<TData, TValue>['cellRenderer']>} renderer
 * @return {*}  {(Pick<ColDef<TData, TValue>, 'valueFormatter' | 'cellRenderer'>)}
 */
export const formattedCell = <TData, TValue>(
  formatter: NonNullable<ColDef<TData, TValue>['valueFormatter']>,
  renderer: NonNullable<ColDef<TData, TValue>['cellRenderer']>
): Pick<ColDef<TData, TValue>, 'valueFormatter' | 'cellRenderer'> => ({
  valueFormatter: formatter,
  cellRenderer: renderer
});
